const driverEvaluate = {
  state: {
    driverName: ''
  },
  mutations: {
    setDriverName(state, payload) {
      state.driverName = payload
    },
    removeDriverName(state) {
      state.driverName = ''
    }
  }
}

export default driverEvaluate
